// side effect: slide session timeout or start new session
import {slideTimeout, startSession} from '../slices/sessionSlice';
import {decision, decisions, fetchConsequences, fetchDecisions} from '../slices/decisionsSlice';

export const sessionMiddleware = store => next => async action => {
    // execute middleware before action
    if (action.type === 'decisions/decision/pending') {
        // after decision(s), slide the session timout
        const now = new Date().getTime();
        const absoluteSecondsLeft = (store.getState().session.timeout.absolute - now) / 1000;
        const slidingSecondsLeft = (store.getState().session.timeout.time - now) / 1000;
        // console.log('session time left', slidingSecondsLeft, absoluteSecondsLeft);
        if (absoluteSecondsLeft < 0 || slidingSecondsLeft < 0) {
            //session expired, start new session
            // start new session and get the featureModel data
            console.log('session expired, restart');

            await store.dispatch(startSession());

            // replay decisions (from defaults and stored data)
            console.log('session expired, replay');
            await store.dispatch(decisions({features: store.getState().decisions?.data?.decisions, attributes: []}));

            //console.log('session expired, fetch');
            await store.dispatch(fetchDecisions());
            await store.dispatch(fetchConsequences());

            // after session is started, send original decision
            await store.dispatch(decision(action.meta.arg));

            console.log('session restarted');
        } else {
            // session not expired, slide timeout
            store.dispatch(slideTimeout());
        }
    }
    return next(action);
};
